<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header
                    :title="$t('esl_change_of_class_requests')"
                    :isColumns="true"
                    @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div
                            class="mb-1"
                            v-for="(column, key) in datatable.columns"
                        >
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile
                    :title="$t('esl_change_of_class_requests')"
                    :isColumns="true"
                    @filter-div-status="datatable.filterStatus = $event"
                >
                    <template v-slot:columns>
                        <div
                            class="mb-1"
                            v-for="(column, key) in datatable.columns"
                        >
                            <b-form-checkbox
                                :id="'checkbox-' + key"
                                :name="'checkbox-' + key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field != 'buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter
                v-show="datatable.filterStatus"
                @filter="filter"
                @filterClear="filterClear"
                :exportExcel="checkPermission('changeofclassrequest_excelexport')"
                @exportExcel="exportExcel"
            >
                <b-row>
                    <b-col cols="12" md="4">
                            <b-form-group :label="$t('module')">
                                <module-date-selectbox ref="moduleDate" v-model="datatable.queryParams.filter.module_date_id" ></module-date-selectbox>
                            </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4">
                            <b-form-group :label="$t('type')">
                                <parameter-selectbox v-model="datatable.queryParams.filter.type"
                                                     code="change_of_class_request_types"
                                />
                            </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4">
                            <b-form-group :label="$t('reason')">
                                <parameter-selectbox v-model="datatable.queryParams.filter.reason"
                                                     code="change_of_class_request_reasons"
                                />
                            </b-form-group>
                    </b-col>
                    <b-col cols="12" md="4">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="datatable.queryParams.filter.status"
                                            :options="statusOptions"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

            </datatable-filter>
            <datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            >
            </datatable>



            <CommonModal
                ref="updateFormModal"
                size="md"
                :onHideOnlyX="true"
                @bHideModalHeaderClose="formClear"
                v-if="checkPermission('changeofclassrequest_update')"
            >
                <template v-slot:CommonModalTitle>
                    {{ $t("edit").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form
                        :formId="formId"
                        :student="student"
                        :available-modules="available_modules"
                        @updateFormSuccess="updateFormSuccess"
                        v-if="formProcess == 'update'"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Components
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox';

// Pages
import UpdateForm from "./UpdateForm";

// Services
import EslChangeOfClassRequestService from "@/services/EslChangeOfClassRequestService";

// Others
import qs from "qs";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,

        UpdateForm,

        CommonModal,
        ModuleDateSelectbox,
        ParameterSelectbox
    },
    metaInfo() {
        return {
            title: this.$t("esl_change_of_class_request"),
        };
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [

                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: "changeofclassrequest_update",
                                callback: (row) => {
                                    this.updateFormShow(row.id);
                                },
                            },
                        ],
                    },
                    {
                        label: this.toUpperCase("id"),
                        field: "id",
                        hidden: true,
                    },
                    {
                        label: this.toUpperCase("student_number"),
                        field: "student_number",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("first_name"),
                        field: "student_name",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("last_name"),
                        field: "student_surname",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("module"),
                        field: "module_date_name",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("type"),
                        field: "type",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("reason"),
                        field: "reason",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("explanation"),
                        field: "explanation",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("status"),
                        field: "status",
                        hidden: false,
                        formatFn: (status) => {
                            if (status === "waiting") {
                                return this.$t("waiting");
                            } else if (status === "approved") {
                                return this.$t("approved");
                            } else if (status === "declined") {
                                return this.$t("declined");
                            } else {
                                return status;
                            }
                        },
                    },
                    {
                        label: this.toUpperCase("directors_note"),
                        field: "directors_note",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("initial_course"),
                        field: "initial_course_name",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("new_course"),
                        field: "course_name",
                        hidden: false,
                    },
                    {
                        label: this.toUpperCase("created_at"),
                        field: "created_at",
                        hidden: false,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "-created_at",
                    page: 1,
                    limit: 20,
                },
            },
            formProcess: null,
            formId: null,
            form: {},
            student: null,
            available_modules: [],
            statusOptions: [
                {value: 'waiting', text: 'Waiting'},
                {value: 'approved', text: this.$t('approved')},
                {value: 'declined', text: this.$t('declined')}
            ],
        };
    },
    created() {
        this.filterSet();
        this.formClear();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {};
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false }),
            };

            return EslChangeOfClassRequestService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;

                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        // Clear
        formClear() {
            this.formId = null;
            this.formProcess = null;
        },

        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },

        // Update
        updateFormShow(id) {
            this.formId = id;
            this.formProcess = "update";
            this.$refs.updateFormModal.$refs.commonModal.show();
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
        exportExcel(){
            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            return EslChangeOfClassRequestService.exportExcel(config)
                .then((response) => {
                    this._downloadFile(response,'Change of Class Requests.xlsx')
                })
                .catch(err=>this.showErrors(err))
        }
    },
};
</script>
